var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExploreIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "40.000000pt",
    height: "40.000000pt",
    viewBox: "0 0 40.000000 40.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,40.000000) scale(0.100000,-0.100000)",
    fill: "#f5f5f5",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183 381 c-3 -10 -23 -26 -46 -35 -47 -18 -46 -32 2 -15 45 16 123 6 158 -19 88 -62 83 -209 -8 -269 -33 -22 -47 -25 -97 -21 -103 7 -159 72 -149 172 2 28 8 60 12 71 7 20 6 20 -9 1 -35 -44 -32 -129 7 -187 27 -41 98 -79 147 -79 49 0 120 38 147 79 63 95 31 211 -74 261 -29 14 -54 33 -57 42 -6 24 -27 23 -33 -1z m27 -11 c0 -5 -4 -10 -10 -10 -5 0 -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145 316 c-41 -18 -83 -69 -91 -111 -19 -102 85 -196 185 -167 103 32 142 152 74 233 -46 54 -109 71 -168 45z m148 -44 c25 -25 31 -41 35 -86 4 -54 3 -57 -36 -96 -36 -36 -44 -40 -91 -40 -44 0 -56 5 -89 34 -35 32 -37 38 -37 94 0 51 4 65 25 87 34 37 57 45 113 41 38 -2 55 -10 80 -34z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190 250 c0 -30 0 -30 -25 -14 -33 21 -42 12 -21 -21 16 -25 16 -25 -14 -25 -46 0 -36 -18 13 -22 42 -3 42 -3 45 -45 4 -49 22 -59 22 -13 0 30 0 30 25 14 33 -21 42 -12 21 21 -16 25 -16 25 14 25 46 0 36 18 -12 22 -43 3 -43 3 -46 46 -4 48 -22 58 -22 12z m31 -81 c10 -19 9 -20 -10 -10 -11 7 -25 21 -32 32 -10 19 -9 20 10 10 11 -7 25 -21 32 -32z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploreIcon);
export default __webpack_public_path__ + "static/media/exploreIcon.6f82bb693fa61a3edb1be72773fdc1d5.svg";
export { ForwardRef as ReactComponent };